import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Carousel",
    description: "Use this for a collection of featured or evergreen stories",
    links: [
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.299oyud8pazv",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/kk4Xyq1Q1FtjeLmbfkWLXX/Section-Fronts?node-id=554-8575&m=dev",
        },
    ],
};
